<template>
  <div id="trackDetail">
    <a-skeleton active :loading="loading" :title="false" :paragraph="{rows:10}">
      <div>
        <div class="header">
          <div class="project_stage" >

            <div v-if="transDealFlag">
              <pt-tag  :text="$t('track.trackDetail.transDeal')" type="triangle"></pt-tag>
            </div>
            <div v-if="pursuitsDO.status != 0 && !transDealFlag ">
              <pt-tag  :text="$t('track.trackStatus.1')" type="triangle"></pt-tag>
            </div>
            <div v-if="pursuitsDO.status == 0 && !transDealFlag ">
              <pt-tag  :text="$t('track.trackStatus.0')" type="triangle"></pt-tag>
            </div>
            <!-- 先隐藏提醒 -->
<!--            <a-tooltip placement="bottom" title="提醒三个月跟进" >-->
<!--              <pt-icon type="icon-xiaoxitixing"  style-obj="font-size:20px;margin-left:30px;color:#666666;font-weight:600"></pt-icon>-->
<!--            </a-tooltip>-->


          </div>
          <div class="function_buttons" v-if="!hideEdit">
            <template v-if="pursuitsDO.status">
              <a-button @click="transferTransaction"><pt-icon type="icon-zhuanjiaoyi1"></pt-icon>{{$t('track.trackDetail.turnIntoDeal')}}</a-button>
              <a-button @click="stopResumeFollowup(0)"><pt-icon type="icon-tingzhi1"></pt-icon>{{$t('track.trackDetail.stopFollowUp')}}</a-button>
<!--              <a-button @click="showFileUpload"><pt-icon type="icon-shangchuanfujian"></pt-icon>{{$t('track.trackDetail.uploadFile')}}</a-button>-->
              <a-button @click="openFollowUP(null)"><pt-icon type="icon-genjin"></pt-icon>{{$t('track.trackDetail.track')}}</a-button>
<!--              <a-button @click="showTips"><pt-icon type="icon-tixing1"></pt-icon>{{$t('deal.dealDetails.dealDetail.remind')}}</a-button>-->
              <a-popover trigger="click" placement="bottomRight" v-model="showMoreButton">
                <div slot="content" style="display:flex;flex-direction: column;" class="more-btn">
                  <div @click="openAddOldLease" class="btn" style="padding-top:4px;"><pt-icon type="icon-zengjia" class="btn-icon"></pt-icon>{{ $t('keyxianyouzuyue') }}</div>
<!--                  <div @click="stopResumeFollowup(0)" class="btn"><pt-icon type="icon-tingzhi1" class="btn-icon"></pt-icon>{{$t('track.trackDetail.stopFollowUp')}}</div>-->
                  <!-- 上传附件 -->
                  <div @click="showFileUpload" class="btn" style="padding-top:4px;"><pt-icon type="icon-shangchuanfujian" class="btn-icon"></pt-icon>{{$t('track.trackDetail.uploadFile')}}</div>
                  <!-- 转交易 -->
<!--                  <div @click="transferTransaction" class="btn" style="padding-top:4px;"><pt-icon type="icon-zhuanjiaoyi1" class="btn-icon"></pt-icon>{{$t('track.trackDetail.turnIntoDeal')}}</div>-->

                  <div v-action:PURSUITSCONTROLLER_DELETE @click="deleteTrack" class="btn" style="padding-bottom:4px;"><pt-icon type="icon-tubiao" class="btn-icon"></pt-icon>{{$t('deal.dealDetails.dealDetail.deleteDeal')}}</div>
                </div>
                <a-button>
                  {{$t('deal.dealDetails.dealDetail.more')}}
                  <a-icon type="caret-right" :rotate="showMoreButton ? -90 : 90" style="font-size:10px;"/>
                </a-button>
              </a-popover>
            </template>
            <template v-else>
              <a-button @click="stopResumeFollowup(1)"><pt-icon type="icon-huifu"></pt-icon>{{$t('track.trackDetail.resumeFollowUp')}}</a-button>
              <a-button v-action:PURSUITSCONTROLLER_DELETE @click="deleteTrack" class="btn"><pt-icon type="icon-tubiao" class="btn-icon"></pt-icon>{{$t('deal.dealDetails.dealDetail.deleteDeal')}}</a-button>
            </template>
          </div>
        </div>
        <div class="content">
          <div class="left">

            <!-- 编辑页面 -->
            <div v-if="isEdit">
              <div>
                <edit-issue ref="editIssueRef" :old-value="pursuitsDO" @saveSuccess="updateDealDetailsSuccess" @error="saveError" @validateFail="updateLoading = false"  >
                  <div slot="header">
                    <a-button @click="isEdit = false" size="small" style="margin-right: 5px;">{{$t('baseVO.cacel')}}</a-button>
                    <a-button type="primary" :loading="updateLoading" size="small" @click="submitDealDetails">{{$t('baseVO.save')}}</a-button>
                  </div>
                </edit-issue>
              </div>
            </div>


            <customer-base @startEdit="isEdit = true" :show-edit="!hideEdit"  v-if="!isEdit" :customer-id="pursuitsDO.customerId" ></customer-base>
            <div class="trackInfoDiv" v-if="!isEdit">
              <!-- 摘要 -->
<!--              <div class="titleRow">-->
<!--                <div class="circleYellow"></div>-->
<!--                <div class="titleText">{{$t('track.trackDetail.summary')}}</div>-->
<!--              </div>-->

              <!-- 追踪 -->
              <div class="titleRow">
                <div class="circleYellow"></div>
                <div class="titleText">{{$t('track.trackDetail.track')}}</div>
              </div>

              <div class="summaryDiv">
                <div class="memberDiv">
                  <div class="memberTitleRow">
                    <div class="follower_text">{{$t('track.trackDetail.helpFollower')}}</div>
                    <div class="addHelperBtn" @click="openHelperModal" v-if="!hideEdit">
                      <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                    </div>
                  </div>
                  <!-- 追踪人员 -->
                  <div class="business_helper">
                    <div v-for="account in pursuitsAccountDOS" :key="account.employeeDO.id" class="user_info">
                      <a-avatar :size="40" :src="getHeadImg(account.employeeDO.headimg)" icon="user"/>
                      <div class="follower_name_row">
                        <div class="follower_name">{{account.employeeDO.userName}}</div>
                      </div>
                    </div>
                  </div>
                  <a-divider></a-divider>
                  <div class="summaryInfo">
                    <pursuitsDetailsComponent ref="pursuitsDetailsComponentRef" :hide-edit="hideEdit" @cancelEditMode="pursuitsDetailsEditVisible = true"
                                              :default-value="pursuitsDO" @onSuccess="pursuitsDetailsSaveSuccess"></pursuitsDetailsComponent>
                  </div>
                </div>
              </div>
              <!-- 需求信息 -->
              <div>
                <demand-information :detail="pursuitsDO" ></demand-information>
              </div>
            </div>
            <div>






              <!-- 可折叠 -->
              <a-collapse :bordered="false" v-model="activeKey" @change="collapseChanges">
                <template v-slot:expandIcon="props">
                  <a-icon type="caret-right" :rotate="props.isActive ? -90 : 90" />
                </template>

                <!-- 关联联系人 -->
                <div >
                  <linkman-table @closeEdit="closeEdit" :linkman-list="linkManDOs" :base-info="pursuitsDO" :mode-type="4" :show-edit-buttons="!hideEdit"
                                 @editLinkman="updateLinkman" @deleteLinkman="deleteLinkman" @addLinkman="addLinkman"></linkman-table>
                </div>

                <!-- 原租赁信息 -->
                <a-collapse-panel key="5"  :style="panelStyle" style="margin-top: 30px">
                  <div slot="header" class="panel_header">
                    <div style="flex: auto;margin-right:40px;display: flex;align-items: center;flex-direction: row;justify-content: space-between">
                      <div style="display: flex;align-items: center;flex-direction: row">
                        <div class="circle"></div>
                        <div class="panel_text">{{$t('track.trackDetail.currentLease')}}</div>
                      </div>
                      <div v-if="oldLeaseDOS.length == 0 ">{{ $t('baseVO.empty') }}</div>
                    </div>
                  </div>
                  <div v-if="oldLeaseDOS.length > 0">
                  <div >
                    <div style="background: #FCFCFC;margin:10px 0px">
                      <div>
                        <pt-tag style="cursor: pointer" v-for="(currentLeaseVO,index) in oldLeaseDOS" :key="index" @click.native="changeLeaseInfo(currentLeaseVO,index)" :color="currentLeaseKey == index ?'default':'grey'" :text="$t('deal.dealDetails.dealDetail.leaseTitle') + (index + 1)" type="triangle" size="small"></pt-tag>
                      </div>
                      <currentLease :defaultValue="currentLeaseVO" @refreshLease="initPursuitsDO" :showEditButton="!hideEdit" :key="currentLeaseKey"></currentLease>
                    </div>
                  </div>
                  </div>
                  <div v-else style="background: #fafbfc;padding:10px 20px;margin-top: 5px;">
                    <pt-empty></pt-empty>
                  </div>
                </a-collapse-panel>



                <!-- 附件 -->
                <a-collapse-panel key="4" :style="panelStyle" >
                  <div slot="header" class="panel_header">
                    <div style="flex: auto;margin-right:40px;display: flex;align-items: center;flex-direction: row;justify-content: space-between">
                      <div style="display: flex;align-items: center;flex-direction: row">
                        <div class="circle"></div>
                        <div class="panel_text">{{$t('track.trackDetail.file')}}</div>
                      </div>
                      <div v-if="dealFiles.length == 0 ">{{ $t('baseVO.empty') }}</div>
                    </div>
                  </div>
                  <div>
                    <div  v-if="dealFiles.length > 0" style="padding: 0 16px 0 20px;">
                      <div v-for="(fileDO,index) in dealFiles" v-bind:key="fileDO.id">
                        <a-divider v-if="index != 0"/>
                        <div class="deal_files" :style="index == 0 ? {marginTop: '16px'} : {}">
                          <div style="margin-right: 10px;">
                            <pt-icon type="icon-fujian" :styleObj="{fontSize: '18px'}"></pt-icon>
                          </div>
                          <div style="flex: 1;font-size: 12px;color: #333333;display: flex; align-items: center;margin-right: 10px;">{{fileDO.fileName}}</div>
                          <div style="display: flex;align-items: center;">
                            <div @click="previewFile(fileDO)"  v-if="$util.matchPreviewType(fileDO.fileName)">
                              <pt-icon class="previewIcon" type="icon-yulancopy" :title="$t('baseVO.preview')"></pt-icon>
                            </div>
                            <div @click="downloadFile(fileDO)" style="margin-left: 20px">
                              <pt-icon class="downloadIcon" type="icon-xiazai" :title="$t('baseVO.download')"></pt-icon>
                            </div>
                            <div @click="deletePursuitsFile(fileDO)" v-if="!hideEdit" style="margin-left: 20px">
                              <pt-icon type="icon-tubiao" :styleObj="{fontSize: '14px', cursor:'pointer'}" :title="$t('baseVO.delete')"></pt-icon>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else style="background: #fafbfc;padding:10px 20px;margin-top: 5px;">
                      <pt-empty></pt-empty>
                    </div>
                  </div>
                </a-collapse-panel>
              </a-collapse>
            </div>
          </div>

          <!-- 右边操作 -->
          <div class="right">
            <div class="customer_records">
              <div class="rightTitleRow">
                <div :class="type == 1 ? 'activeTitle':'defaultTitle'"  @click="switchType(1)">
                  <div class="titleFont">{{$t('track.trackDetail.trackRecords')}}</div>
                  <div class="activeLine"></div>
                </div>

<!--                <div style="width: 1px;background: #F0F0F0;"></div>-->
                <div :class="type == 2 ? 'activeTitle':'defaultTitle'" v-if="!hideEdit"  @click="switchType(2)">
                  <div class="titleFont">{{$t('deal.dealDetails.dealDetail.historyDealAndNeed')}}</div>
                  <div class="activeLine"></div>
                </div>

              </div>

              <div style="padding:0px 20px;">
                <a-divider></a-divider>
              </div>
<!--              边界问题-->
              <div class="mainDiv">
                <div>
                  <div v-if="type == 1" class="listDiv">
                    <customerRecordList :business-type='2' :datadict-childs='datadictChilds' :customer-records="customerRecords" @showCustomerRecord="openFollowUP" :showEditButtons="!hideEdit"
                                        :list-pagination="listPagination" ></customerRecordList>
                  </div>
                  <div v-if="type == 2"  class="listDiv">
                    <history-deal-and-demand :customer-id="pursuitsDO.customerId" :pursuitsId="pursuitsId" :list-pagination="listPagination"></history-deal-and-demand>
<!--                    <reminderList :reminderQuery="{businessId:pursuitsDO.id,remindType:'2'}" @editReminder="editReminder" :showEditButtons="!hideEdit"></reminderList>-->
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </a-skeleton>

    <pt-select-user :visible="helperModal.visible" @close="cancelAddHelper" @ok="selectResultEvent"
                    v-model="pursuitsAccountEmployees" ref="selectUserRef" :title="$t('deal.addDeal.dealDetails.addHelperIds')"></pt-select-user>

    <customerRecord :customer-id='pursuitsDO.customerId' :pursuits-id="pursuitsId" :visible="customerRecordVisible" :track-status="true"
                    :defaultValue="defaultCustomerRecord" :loading="customerRecordLoading" :modalTitle="$t('track.trackDetail.track')"
                    @hide="hideCustomerRecord" @confirmDemand="getDemandStatus" @saveSuccess="customerRecordSuccess" ref="customerRecordRef" :typeChangeVisible="true"></customerRecord>

    <uploadFile :pursuitsId="pursuitsId" :visible="pursuitsFileUploadvisible" @onSuccess="onSuccess" @cancel="hideDealFileUpload"></uploadFile>
    <!--<pt-modal :title="$t('track.trackModal.addCustomer')" :visible="dealSourceModalVisible"-->
              <!--@ok="saveDealSource" @cancel="cancelDealSource" :width="800"-->
    <!--&gt;-->
      <!--<div slot="content">-->
        <!--<a-form :form="dealSourceForm" layout="vertical">-->
          <!--<a-row>-->
            <!--<a-col :span="8">-->
              <!--<a-form-item :label="$t('deal.addDeal.dealSource.sourceUsers')" class="required">-->
                <!--<ptSelect v-decorator="decorators.dealSourcePersonStringList"-->
                          <!--mode="multiple">-->
                  <!--<a-select-option v-for="a in accountList" :key="a.id" :value="a.id">{{a.loginName}}</a-select-option>-->
                <!--</ptSelect>-->
              <!--</a-form-item>-->
            <!--</a-col>-->
            <!--<a-col :span="8">-->
              <!--<a-form-item :label="$t('deal.addDeal.dealSource.sourceType')" class="required">-->
                <!--<pt-select v-decorator="decorators.sourceType">-->
                  <!--<a-select-option v-for="o in dealSourceTypes" :value="o.wordKey" :key="o.wordKey">{{o.wordValue}}</a-select-option>-->
                <!--</pt-select>-->
              <!--</a-form-item>-->
            <!--</a-col>-->
            <!--<a-col :span="8">-->
            <!--</a-col>-->
          <!--</a-row>-->
        <!--</a-form>-->
      <!--</div>-->
    <!--</pt-modal>-->
    <pt-modal :title="$t('lease.detail.title')" :visible="leaseDetailsVisible"
              :width="800" @cancel="hideLeaseDetails" @ok="hideLeaseDetails" :footer="true"
    >
      <div slot="content">
        <lease-detail :leaseId="leaseId" :showTopButton="false"></lease-detail>
      </div>
    </pt-modal>
    <pt-modal :title="$t(addLeaseTitle)" :visible="addLeaseVisible" :loading="saveLeaseLoading"
              @ok="submitEvent" @cancel="cancelEvent" :width="800"
    >
      <div slot="content">
        <add-lease ref="addLeaseRef" :defaultCustomerId="pursuitsDO.customerId"
                   :defaultAreaUnit="defaultAreaUnit" :defaultRentUnit="defaultRentUnit"></add-lease>
      </div>
    </pt-modal>
    <pt-modal :title="this.$t('deal.dealDetails.dealDetail.pursuitsToDeal')" :visible="addDealShow" :loading="addDealLoading"
              @ok="submitAddDeal" @cancel="cancelAddDeal" :width="800"
    >
      <div slot="content">
        <addDeal ref="addDealRef"  :dealOriginType="1" :dealType="[pursuitsDO.pursuitsType]" @validateFail="addDealLoading = false"
                 :pursuitsToDealVO="pursuitsToDealVO" @transferSuccess="transferSuccess"></addDeal>
      </div>
    </pt-modal>
    <addTips :loading="tipLoading" :visible="tipsVisible" @saveSuccess="tipsSaveSuccess" @hide="hideTips" :pursuitsId="pursuitsDO.id" ref="addTipsRef"></addTips>
  </div>
</template>

<script>
  import addTips from '../../deal/addTips'
  import leaseDetail from '../../../database/lease/module/leaseDetail'
  import accountApi from '@/api/mine/account'
  import customerRecord from '../../customer/editCustomerRecord'
  import addFollower from './addFollower'
  import pursuitsApi from '@/api/mine/pursuit'
  import pursuitsAccountApi from '@/api/mine/pursuitsAccount'
  import pursuitsLinkmanApi from '@/api/mine/pursuitsLinkman'
  import pursuitsFilesApi from '@/api/mine/pursuitsFiles'
  import customerRecordApi from '@/api/mine/customerRecords'
  import uploadFile from '../../deal/uploadFile'
  import demandInformation from '@/views/mine/pursuits/module/demandInformation'
  import pursuitsDetailsComponent from './pursuitsDetailsComponent'
  import currentLease from '../../deal/dealCurrentLease'
  import editLinkman from '../../deal/editLinkman'
  import customerRecordList from '../../customer/customerRecordList'
  import reminderList from '../../reminder/reminderList'
  import { getDatadictChildsByPath } from '@/api/sys/datadict'
  import addLease from '@/views/database/lease/module/addLease'
  import { getByCompanyIdAndType, unitTypeEnum } from '@/api/manager/unitUse'
  import addDeal from '../../deal/addDeal'
  import CustomerBase from '@/views/database/customer/module/customerBase'
  import editIssue from '@/views/mine/pursuits/module/editIssue'
  import historyDealAndDemand from '@/views/mine/pursuits/module/historyDealAndDemand'

  export default {
    name: 'trackDetail',
    components:{
      historyDealAndDemand,
      CustomerBase,demandInformation,editIssue,
      addFollower, customerRecord, uploadFile, pursuitsDetailsComponent, currentLease,
      editLinkman,leaseDetail, customerRecordList, reminderList, addTips, addLease, addDeal
    },
    props:{
      pursuitsId:{
        type: String,
        default: null
      },
      hideEdit:{
        type:Boolean,
        default: false,
      },
      transDealFlag:{
        type:Boolean,
        default: false,
      },
    },
    computed:{
      oldLeaseDOS(){
        if(this.pursuitsDO.leaseLeaseInfoTypeVOS){
          let arr = this.pursuitsDO.leaseLeaseInfoTypeVOS.filter(e=>{return e.newLease == false}).map(f=>{return f.leaseLeaseInfoVO})
          this.currentLeaseVO = arr[0]
          this.currentLeaseKey = 0
          return arr;
        }else{
          return []
        }
      }
    },
    data(){
      return {
        tipLoading:false,
        isEdit:false,
        customerRecordLoading:false,
        currentLeaseVO:{},
        updateLoading:false,
        saveLeaseLoading: false,
        addDealLoading: false,
        currentLeaseKey:0,
        listPagination:{
          onChange: page => {
            this.listPagination.current = page
            this.initCustomerRecords()
          },
          hideOnSinglePage:true,
          size:'small',
          defaultPageSize:5,
          pageSize:5,
          current: 1,
        },
        addDealShow: false,
        pursuitsToDealVO: null,
        defaultAreaUnit:null,
        defaultRentUnit:null,
        newLease:null,
        addLeaseTitle:'',
        newDemandStatus:null,
        showMoreButton: false,
        addLeaseVisible:false,

        type:1,
        reminderDO:null,
        tipsVisible:false,
        leaseId:null,
        leaseDetailsVisible:false,
        pursuitsDetailsEditVisible:true,
        loading:false,
        linkmandEditVisible: true,
        decorators: {
          dealSourcePersonStringList:[
            'dealSourcePersonStringList', { rules: [{ required: true, message: this.$t('deal.addDeal.dealSource.errorInfo.sourceUsers')}] }
          ],
          sourceType: [
            'sourceType', { rules: [{ required: true, message: this.$t('deal.addDeal.dealSource.errorInfo.sourceType')}] }
          ],
          sourcePath: [
            'sourcePath', { rules: [{ required: true, message: this.$t('deal.addDeal.dealSource.errorInfo.sourcePath')}] }
          ],
        },
        pursuitsAccountDOS:[],
        defaultCustomerRecord:null,
        pursuitsAccountEmployees:[],
        accountList:[],
        dealSourcePaths:[],
        dealSourceTypes:[],
        dealSourcePersonStringList:[],
        dealSourceForm: this.$form.createForm(this,{}),
        pursuitsFileUploadvisible: false,
        // dealSourceModalVisible: false,
        customerRecords:[],
        customerRecordVisible: false,
        activeKey:['1','2','3'],
        pursuitsDO:{},
        linkManDOs:[],
        panelStyle: 'background: #FFFFFF;border: 0;margin-bottom:30px;',
        styleObj:{fontSize: '12px',padding:'4px',lineHeight:'16px',background: '#ECECEC',
          borderTop: '1px solid #DCDCDC',borderLeft: '1px solid #DCDCDC',borderBottom: '1px solid #DCDCDC',color:' #666666'
        },
        triangleTopStyleObj:{borderWidth: '10px 12px 12px 7px',top:'0',borderLeftColor: '#ECECEC'},
        triangleBottomStyleObj:{borderWidth: '12px 16px 13px 8px',borderLeftColor: '#DCDCDC'},
        dealFiles:[],
        brokerageRecords:[],
        helperModal:{
          visible:false,
        },
        datadictChilds:[]
      }
    },
    mounted(){
      console.log('this.pursuitsId',this.pursuitsId)
      if(this.pursuitsId != null){
        this.init()
      }
    },
    methods:{
      getRelationsSelects() {
        getDatadictChildsByPath('system.business_key.relation').then(res => {
          console.log('getRelationsSelects',res.data)
          this.datadictChilds = res.data

        })
      },
      stopResumeFollowup(value){
        this.isEdit = false
        this.showMoreButton = false
        let update = JSON.parse(JSON.stringify(this.pursuitsDO))
        update.status = value
        pursuitsApi.changePursuitsStatus(update).then(res=>{
          if(res.code == 1){
            this.initPursuitsDO()
            this.$emit('refreshList',true)
            this.$message.success(res.message)
          }else{
            this.$message.error(res.message)
          }
        })
      },
      changeLeaseInfo(leaseInfo,index){
        this.currentLeaseVO = leaseInfo
        this.currentLeaseKey = index
      },
      cancelAddDeal(){
        this.addDealShow = false
      },
      submitAddDeal(){
        this.addDealLoading = true
        this.$refs.addDealRef.submitPursuitsTransferToDeal()
      },
      cancelEvent(){
        this.addLeaseVisible = false
      },
      deleteTrack(){
        let _this = this
        this.showMoreButton = false
        this.$ptConfirm({
          content: _this.$t('track.trackDetail.deleteTrackWarning'),
          okType: 'primary',
          onOk() {
            _this.deletePursuits()
          },
          onCancel() {

          },
        });
      },
      deletePursuits(){
        pursuitsApi.deletePursuits({id:this.pursuitsId}).then(res=>{
          if(res.code == 1){
            this.$message.success(res.message)
            this.$emit('refreshList',true)
          }else{
            this.$message.error(res.message)
          }
          this.showMoreButton = false
        })
      },
      openAddOldLease(){
        this.isEdit = false
        this.initDefaultUnit()
        this.newLease = false
        this.showMoreButton = false
        this.addLeaseTitle = this.$t('baseVO.add') + this.$t('deal.dealDetails.dealDetail.addOldLease')
      },
      initDefaultUnit(){
        Promise.all([this.initDefaultAreaUnit(),this.initDefaultRentUnit()]).then(()=>{
          this.addLeaseVisible = true
        })
      },
      initDefaultRentUnit(){
        let p = new Promise((resolve,reject)=>{
          getByCompanyIdAndType(unitTypeEnum.RENT).then(res=>{
            if(res.code == 1){
              this.defaultRentUnit = res.data[0]
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      initDefaultAreaUnit(){
        let p = new Promise((resolve,reject)=>{
          getByCompanyIdAndType(unitTypeEnum.AREA).then(res=>{
            if(res.code == 1){
              this.defaultAreaUnit = res.data[0]
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      showTips(){
        this.reminderDO = null
        this.tipsVisible = true
      },

      saveError(){
        this.updateLoading = false;
      },


      editReminder(value){
        this.tipsVisible = true
        this.reminderDO = value
        this.$nextTick(()=>{
          this.$refs.addTipsRef.setDefaultValue(this.reminderDO)
        })
      },
      switchType(type){
        this.type = type;
      },

      updateDealDetailsSuccess(){
        this.updateLoading = false
        this.$emit('refreshList')
        this.init();
        this.isEdit = false;

      },

      submitDealDetails(){
        this.updateLoading = true;
        this.$refs.editIssueRef.submitPursuit()
      },

      showLeaseDetails(leaseId){
        this.leaseId = leaseId
        this.leaseDetailsVisible = true;
      },
      hideLeaseDetails(){
        this.leaseDetailsVisible = false;
      },
      updateLinkman(){

      },
      deleteLinkman(){

      },
      addLinkman(){

      },
      closeEdit(){
        this.isEdit = false
      },
      getHeadImg(headimg){
        return this.$util.getFileUrl(headimg)
      },
      // cancelDealSource(){
      //   this.dealSourceModalVisible = false
      // },
      collapseChanges(key){
        if(key.indexOf("4") >= 0){
          this.initFiles()
        }
      },
      customerRecordSuccess(){
        let this_ = this
        this.init()
        //无需求
        console.log('this_.newDemandStatus',this_.newDemandStatus)
        if(this_.newDemandStatus == '1' ){
          this_.hideCustomerRecord()
          this_.$ptConfirm({
            content: '该企业追踪状态已变为无需求，是否需要停止追踪该企业？',
            onOk() {
              this_.stopResumeFollowup(0)
            },
            onCancel() {
              this_.hideCustomerRecord()
            },
          })
          //转交易
        }else if(this_.newDemandStatus == '4' ){
          this_.hideCustomerRecord()
          this_.$ptConfirm({
            content: '该企业追踪状态已变为有需求，是否要转为交易？',
            onOk() {

              this_.transferTransaction()
            },
            onCancel() {
              this_.hideCustomerRecord()
            },
          })
        }else{
          this_.hideCustomerRecord()
        }
        this_.$emit('refreshList',false)
      },
      getDemandStatus(value){
        this.newDemandStatus = value
      },
      deletePursuitsFile(file){
        let this_ = this
        this.$ptConfirm({
          title: this_.$t('confirmInfo.deleteFile.title'),
          content: this_.$t('confirmInfo.deleteFile.content'),
          onOk() {
            return new Promise((resolve, reject) => {
              pursuitsFilesApi.deleteFile(file.pursuitsFileDO).then(res=>{
                if(res.code == 1){
                  this_.$message.success(res.message)
                  this_.initFiles()
                  resolve()
                }else{
                  this_.$message.error(res.message)
                  reject()
                }
              })
            }).catch(() => console.log('Oops errors!'));
          },
          onCancel() {},
        })
      },
      previewFile(file){
        this.$util.previewFile(file.id)
      },
      downloadFile(file){
        this.$util.dowLoadFile(file.id,file.fileName,this);
      },
      init(){

        this.getRelationsSelects()
        this.initPursuitsDO()
        this.initCustomerRecords()
        this.initLinkmanDOs()
        this.initPursuitsAccountVO()
        this.initDealSource();
        this.initFiles();
      },
      initAccount(){
        accountApi.listAll().then(res=>{
          this.accountList = res.data
        })
      },
      initLinkmanDOs(){
        let this_ = this
        pursuitsLinkmanApi.selectByPursuitsId(this.pursuitsId).then(res=>{
          if(res.code == 1){
            this_.linkManDOs = res.data.records
          }
        })
      },

      initDealSource(){
        let this_ = this
        getDatadictChildsByPath('system.business_key.deal_source_set').then(res=>{
          this_.dealSourceTypes = res.data.filter(e=>{return e.wordKey != 'invited' && e.wordKey != 'approach'})
        })
      },
      linkmanEditMode(){
        this.linkmandEditVisible = false
        this.$refs.editLinkmanRef.toEditMode()
      },
      onSuccess(){
        this.initFiles()
        this.pursuitsFileUploadvisible = false
      },
      hideDealFileUpload(){
        this.pursuitsFileUploadvisible = false
      },
      hideCustomerRecord(){
        this.$refs.customerRecordRef.DemandStatusType = false
        this.customerRecordVisible = false
        this.defaultCustomerRecord = null
        this.customerRecordLoading = false;
      },
      initCustomerRecords(){
        customerRecordApi.selectByBusinessId(this.pursuitsId, 'pursuits',2,{
          current:this.listPagination.current,
          size:this.listPagination.pageSize,
        }).then(res=>{
          if(res.code == 1){
            console.log('customerRecordscustomerRecordscustomerRecords',res.data.records)
            this.customerRecords = res.data.records
            this.listPagination.total = res.data.total
          }else{

          }
        })
      },
      initPursuitsDO(){
        let this_ = this
        this.loading = true
        pursuitsApi.selectOne(this.pursuitsId).then(res=>{
          if(res.code == 1){
            console.log('asdasdasd',res.data)
            this_.pursuitsDO = res.data
          }else{

          }
        }).finally(()=>{
          this.loading = false
        })
      },
      initPursuitsAccountVO(){
        pursuitsAccountApi.listAllByPursuitsId(this.pursuitsId).then(res=>{
          if(res.code == 1){
              this.pursuitsAccountDOS = res.data
          }else{

          }
        })
      },
      initFiles(){
        let this_ = this
        pursuitsFilesApi.selectByPursuitsId(this.pursuitsId).then(res=>{
          if(res.code == 1){
            this_.dealFiles = res.data.records
          }else{
            this_.dealFiles = [];
          }
        })
      },
      linkmanSaveSuccess(){
        this.initLinkmanDOs()
        this.linkmandEditVisible = true
      },
      openHelperModal(){
        this.pursuitsAccountEmployees = this.pursuitsAccountDOS.map(e=>{return e.employeeDO})
        this.helperModal.visible = true;
      },
      openFollowUP(record){
        this.isEdit = false
        this.customerRecordVisible = true
        this.$refs.customerRecordRef.demandStatus = this.pursuitsDO.demandStatus
        this.$refs.customerRecordRef.oldDemandStatustr = this.pursuitsDO.demandStatus
        this.$refs.customerRecordRef.DemandStatusType = true
        this.$refs.customerRecordRef.selectCustomerRecords()
        if(record){
          this.defaultCustomerRecord = record
          this.$nextTick(()=>{
            this.$refs.customerRecordRef.initDefaultValue()
          })
        }
      },
      pursuitsDetailsEdit(){
        this.$refs.pursuitsDetailsComponentRef.toEditMode()
        this.pursuitsDetailsEditVisible = false
      },
      saveHelper(){
        this.helperModal.visible = false;
      },
      // saveDealSource(){
      //   this.dealSourceForm.validateFields(err=>{
      //     if(!err){
      //       let dealSourceVO = this.dealSourceForm.getFieldsValue()
      //       dealSourceVO.dealSourcePersonDOS = dealSourceVO.dealSourcePersonStringList.map(e=>{return {userId:e}})
      //       pursuitsApi.transferTransaction(this.pursuitsId, dealSourceVO).then(res=>{
      //         if(res.code == 1){
      //           this.$message.success(res.message)
      //           this.cancelDealSource()
      //           this.$emit('transferSuccess')
      //         }else{
      //           this.$message.error(res.message)
      //         }
      //       })
      //     }
      //   })
      // },


      pursuitsDetailsSaveSuccess(){
        this.$emit('pursuitsDetailsSaveSuccess')
        this.pursuitsDetailsEditVisible = true
        this.initPursuitsDO()
      },
      selectResultEvent(value){
        let pursuitsAccountVO = this.pursuitsAccountEmployees.map(e=>{
          return {pursuitsId:this.pursuitsId,employeeDO:e}
        })
        if(pursuitsAccountVO.length == 0 ){
          this.$message.error("追踪团队不能为空")
        }else{
          pursuitsAccountApi.updateByPursuitsId(pursuitsAccountVO).then(res=>{
            if(res.code == 1){
              this.$message.success(res.message)
              this.initPursuitsAccountVO(this.pursuitsId)
              this.init()
            }else{
              this.$message.error(res.message)
            }
          })
        }
      },
      hideTips(){
        this.tipsVisible = false
        this.tipLoading = false
      },
      transferSuccess(){
        this.addDealShow = false
        this.$emit('transferSuccess')
      },
      tipsSaveSuccess(){
        this.hideTips()
        this.initPursuitsDO()
      },
      showFileUpload(){
        this.isEdit = false
        this.showMoreButton = false
        this.pursuitsFileUploadvisible = true
      },
      submitEvent(){
        let leaseLeaseInfoVO = this.$refs.addLeaseRef.extractLeaseInfoVO()
        if(!leaseLeaseInfoVO){
          return
        }
        let LeaseLeaseinfoTypeVO = {businessId: this.pursuitsId, newLease: false, leaseLeaseInfoVO: leaseLeaseInfoVO }
        this.saveLeaseLoading = true
        pursuitsApi.saveOldLease(LeaseLeaseinfoTypeVO).then(res=>{
          if(res.code == 1){
            this.addLeaseVisible = false
            this.initPursuitsDO()
            this.$message.success(res.message)
          }else{
            this.$message.error(res.message)
          }
          this.saveLeaseLoading = false
        })
      },
      transferTransaction(){

        this.isEdit = false
        this.showMoreButton = false
        this.pursuitsToDeal().then(res=>{
          this.addDealShow = true
        })
      },
      pursuitsToDeal(){
        let p = new Promise((resolve,reject) => {
          pursuitsApi.pursuitsToDeal(this.pursuitsDO.id).then(res=>{
            if(res.code == 1){
              this.pursuitsToDealVO = res.data
              this.pursuitsToDealVO.projectStages += ''
              this.pursuitsToDealVO.pursuitsId = this.pursuitsDO.id
              delete this.pursuitsToDealVO.budgetRentUnit
              delete this.pursuitsToDealVO.totalBrokerageUnit
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      cancelAddHelper(){
        this.helperModal.visible = false;
      }
    },
    watch:{
      pursuitsId(){
        this.initPursuitsDO()
      }
    }
  }
</script>

<style scoped lang="less">
  .ant-collapse-borderless{
    background-color: #ffffff !important;
  }
  .ant-row{
    padding: 10px;
  }
  #trackDetail{
    .rightTitleRow{
      width: 50%;
      display: flex;
      flex-direction: row;
      .activeTitle{
        padding-top: 10px;
        width: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor:pointer;
        align-self: flex-end;
        .titleFont{
          font-size: 14px;
          color: #000000;
        }
        .activeLine{
          margin-top: 12px;
          background: #FABE00;
          width: 50px;
          height:4px;
        }
      }
      .defaultTitle{
        width: 50%;
        padding-top: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        //background: #ffffff;
        cursor:pointer;
        align-self: flex-end;
        //border-bottom: 1px solid #F0F0F0;
        .titleFont{
          font-size: 14px;
          color: #999999;
        }
        .activeLine{
          margin-top: 12px;
          background: transparent;
          width: 50px;
          height:4px;
        }
      }
    }
    .tabRow{
      background: #FCFDFD;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      .tabItem{
        height: 50px;
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor:pointer;
        position: relative;
        .tabText{
          font-size: 14px;
          color: #999999;
          text-align: center;
        }
        .bottomLine{
          width: 50px;
          height: 4px;
          background: transparent;
          position: absolute;
          bottom: 0;
        }
      }
      .tabItem:hover{
        .tabText{
          color:#333333;
        }
      }
      .tabItemActive{
        height: 50px;
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor:pointer;
        background: #FFFFFF;
        position: relative;
        .bottomLine{
          width: 50px;
          height: 4px;
          background: #FABE00;
          position: absolute;
          bottom: 0;
        }
        .tabText{
          font-size: 14px;
          color: #333333;
          position: relative;
          text-align: center;
        }
      }
      .unreadDiv{
        position: absolute;
        top: -6px;
        right: -18px;
        background: #FABE00;
        border-radius: 10px;
        font-size: 12px;
        line-height: 20px;
        padding: 0 6px;
        color: #FFFFFF;
      }
    }
    .listDiv{
      padding: 10px 20px;
      width: 400px;
    }

    background: #FCFDFD;
    .project_name{
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .trackInfoDiv{
      .titleRow{
        background: #FAFBFC;
        height: 40px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 5px;
        .circleYellow{
          width: 12px;
          height: 12px;
          background: #FABE00;
          border-radius: 50%;
          margin: 0 10px;
        }
        .titleText{
          font-size: 14px;
          color: #333333;
          font-weight: bold;
        }
      }
      .summaryDiv{
        background: #FAFBFC;
        padding: 20px 20px 0 20px;
        margin-bottom: 30px;
        .memberDiv{

        }
        .memberTitleRow{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .follower_text{
            font-size: 12px;
            color: #999999;
          }
          .addHelperBtn{
            width: 16px;
            height: 16px;
            border: 1px solid #8E8E8E;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            .addIcon{
              font-size: 12px;
              color: #8E8E8E;
            }
          }
          .addHelperBtn:hover{
            border: 1px solid #FABE00;
            .addIcon{
              color: #FABE00;
            }
          }
        }
        .business_helper{
          padding-top: 11px;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          .user_info{
            margin-right: 20px;
            text-align: center;
            margin-bottom: 4px;
          }
          .follower_name_row{
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 4px;
          }
          .follower_name{
            font-size: 12px;
            color: #4D4D4D;
          }
        }
      }
    }
    .header{
      display: flex;
      justify-content: space-between;
      padding: 8px 0;
      background: #FAFBFC;
      width: 100%;
      left: 0;
      top: 0;
      .project_stage{
        display: flex;
        align-items: center;
      }
      .function_buttons{
        display: flex;
        justify-content: space-around;
        .ant-btn{
          margin-right: 20px;
        }
      }
    }
    .content{
      .title{
        font-size: 12px;
        color: #999999;
      }
      .content_text{
        font-size: 12px;
        color: #333333;
      }
      background-color:#ffffff;
      padding:0;
      display: flex;
      .left{
        padding:10px 20px;
        background: #FFF;
        flex: 1 0 650px;
        min-width: 650px;
        .users{
          display: flex;
          padding: 20px 10px 10px 10px;
          .main_follower{
            flex: 4;
          }
          .follower_text{
            font-size: 14px;
            color: #999999;
            margin-bottom: 10px;
          }
          .follower_name_row{
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 5px;
          }
          .follower_name{
            font-size: 14px;
            color: #4D4D4D;
          }
          .delIcon{
            font-size: 10px;
            margin-left: 6px;
            cursor:pointer;
          }
          .helpers{
            flex: 6;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .business_helper{
              padding-top: 11px;
              display: flex;
              justify-content: flex-start;
              flex-wrap: wrap;
              .user_info{
                margin-right: 20px;
                text-align: center;
                margin-bottom: 10px;
              }
            }
          }
        }
        .customer_name{
          font-size: 17px;
          color: #333333;
        }
        .panel_header{
          display: flex;
          align-items: center;
          .circle{
            margin-left: 12px;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background-color: #FABE00;
          }
          .panel_text{
            padding: 0 10px;
            color: #333333;
            font-size: 14px;
            font-weight: bold;
          }
        }
        .ant-col-8, .ant-col-24{
          display: flex;
        }
        .deal_files{
          display: flex;
        }
        .ant-divider-horizontal{
          margin: 10px 0;
        }
      }
      .right{
        background:#FCFDFD;
        flex: 1 0 350px;
        max-width: 500px;
        padding-bottom: 30px;
        .customer_records{

          .mainDiv{
            padding-right: 10px;
          }


          .follower_type{
            padding: 1px 11px;
            font-size: 12px;
            color: #95AAC9;
            background: #F9FBFD;
            border: 1px solid #DEE4EC;
          }
          .follower_header{
            height: 40px;
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #999999;
            margin-bottom: 10px;
          }
          .follower_stage{
            display: flex;
            font-size: 12px;
            color: #999999;
            margin-bottom: 10px;
          }
          .follower_comment{
            font-size: 12px;
            color: #333333;
            letter-spacing: 0;
          }
        }
      }
      .linkman{
        display: flex;
        border: 1px solid #EFF1F5;
        align-items: center;
        margin-bottom: 10px;
        .linkman_icon{
          padding: 10px 15px;
          background-color: #FBFBFC;
          margin-right: 10px;
        }
        .linkman_title{
          font-size: 12px;
          color: #999999;
        }
        .linkman_content{
          font-size: 12px;
          color: #333333;
        }
      }
    }
  }
</style>
<style lang="less">
  #trackDetail{
    .ant-collapse .ant-collapse-item .ant-collapse-header .anticon {
      left: initial;
      right: 16px;
    }
    .ant-collapse > .ant-collapse-item > .ant-collapse-header{
      padding: 9px 0px 9px 0px;
      background: #FAFBFC;
      margin-left: 0 !important;
    }
    .ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box{
      padding: 0;
    }
  }
  .more-btn{
    .btn{
      cursor:pointer;
      padding: 8px 0;
      .btn-icon{
        margin-right: 10px;
      }
    }
  }
</style>